import styled from 'styled-components';

export const ResourceDetailEditButton = styled.button`
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  padding: 16px 48px 16px 40px;

  border-radius: 100px;
  background: var(--color-data-people-background);

  opacity: ${({ theme }) => (theme.canSeeButNotEdit ? 0.5 : 1)};
  cursor: ${({ theme }) => (theme.canSeeButNotEdit ? 'default' : 'pointer')};

  float: right;
`;

export const ResourceDetailEditButtonLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: var(--color-text);
`;
